import axios from "axios";

const token = (): string => localStorage.getItem("tokens") ?? "";
export const getAccessToken = (): string => {
  try {
    return token() ? JSON.parse(token()).access_token : "";
  } catch (e) {
    console.error("Error parsing access token:", e);
    return "";
  }
};

const UNAUTHORIZED_ERROR_CODE = 401;

const URL = process.env.REACT_APP_API_URL ?? "";
const environment = process.env.REACT_APP_ENV ?? "";
const version = process.env.REACT_APP_VERSION ?? "";

const baseURL = `${URL}/${environment}/${version}`;

export const AxiosInstance = axios.create({
  baseURL,
  headers: {
    "Cache-Control": "no-cache",
    Authorization: `Bearer ${getAccessToken()}`,
  },
});
AxiosInstance.interceptors.request.use(
  function (config) {
    config.headers.Authorization = `Bearer ${getAccessToken()}`;
    // Do something before request is sent
    return config;
  },
  async function (error) {
    // Do something with request error
    return await Promise.reject(
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      new Error("Error in request interceptor" + error)
    );
  }
);
AxiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === UNAUTHORIZED_ERROR_CODE) {
      // eslint-disable-next-line no-console
      console.error(error.response);
    } else if (error?.response?.status === 500) {
      // eslint-disable-next-line no-console
      console.error(error.response);
    } else if (error?.message) {
      // eslint-disable-next-line no-console
      console.error(error.message);
    }
    return await Promise.reject(error);
  }
);

export default AxiosInstance;
